export default class Modal {
  constructor() {
    this.modal = document.querySelector('.modal');
    this.modalTrigger = document.querySelectorAll('[data-modal]');
    if (this.modalTrigger.length === 0 || !this.modal) return;

    this.init();
    this.initCloseButton();
  }

  init() {
    let modalImage = this.modal.querySelector('.modal__image');
    this.modalTrigger.forEach(trigger => {
      trigger.addEventListener('click', () => {
        let zoomableImage = trigger.dataset.modal ? document.querySelector('#'+trigger.dataset.modal) : trigger;
        modalImage.setAttribute('src', zoomableImage.getAttribute('src'));
        this.modal.classList.add('modal--active');
      })
    });
  }

  initCloseButton() {
    let closeButton = this.modal.querySelector('.modal__close');
    closeButton.addEventListener('click', () => this.modal.classList.remove('modal--active'))
  }
}
